import { FC } from 'react'
import { Text, TextProps } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

const Chip: FC<TextProps> = ({ children, style, ...props }) => {
    const { styles } = useStyles(stylesheet)

    return (
        <Text {...props} style={[styles.chip, style]}>
            {children}
        </Text>
    )
}

const stylesheet = createStyleSheet((theme) => ({
    chip: {
        fontFamily: theme.fonts.bold,
        fontSize: 12,
    },
}))

export default Chip
